import { useState, useRef, useEffect, useCallback } from 'react';
import getXcolumnJson from "./xcolumn/list";
import ListComponent from '@/pcomponents/common/crud/list/list/list_component';
import strFunc from '@/lib/lyg/string';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios/index";
import ExcelUploadArea from "@/pcomponents/common/excel/excel_upload_popup";
import DateFunc from '@/lib/lyg/date_func';
import { useSelector, useDispatch } from 'react-redux';

function WriteMultyPopup(props: any) {
  const myProps = {
    closePopup: () => { },
    callback: () => { },
    isUpdate: false,
    listOpt: {},
    row_num: 0,
    key: "",
    callBackData: (data: any) => {
      let optObj = {
        info_arr: [],
        row_num: 0,
        key: "",
      };
    },//data = { info_arr:[],row_num:0,key:"" };
    ...props
  };
  let user = useSelector((state: any) => state.user);
  const xColumnArr = getXcolumnJson();
  const ListComponentRef = useRef<any>();
  const [pageData, setPageData] = useState({
    listOpt: {
      ...xColumnArr.list_opt,
      ...myProps.listOpt
    }
  });
  const [infoArr, setInfoArr] = useState<any>([]);
  const [isOpenExcel, setIsOpenExcel] = useState(false);
  const [last_id_num, set_last_id_num] = useState("");
  const [mcomp_info, set_mcomp_info] = useState<any>({
    "a_id_prefix": "",
  });

  useEffect(() => {
    get_last_user_id_num();
    get_mcomp_info_by_ajax();
  }, [user]);

  let default_row_data = {
    "a_seq": "",
    "a_corp_seq": "1",
    "a_user_id": "",
    "a_user_pw": "",
    "a_user_grade": "student",
    "a_is_login": "1",
    "a_user_name": "",
    "a_user_phone": "",

    "a_stu_state": "now",
    "a_stu_num": "",
    "a_class_seq": "",
    "a_gender": "",
    "a_school_name": "",
    "a_stu_grade": "",
    "a_join_date": DateFunc.get_date_format(new Date(), "Y-m-d"),
    "a_stu_birth_date": "",
    "a_stu_supply_day": "",
    "a_stu_supply_discount": "0",
    "a_memo": "",

    "par_relation": "모",
    "par_phone": "",
    "par_user_id": "",
    "par_user_pw": "",
    "par_is_attend_sms": "",
    "par_is_attend_push": "1",
    "par_is_attend_katalk": "",
  };

  const get_last_user_id_num = () => {
    let form_json_data: any = {
      "pre_fix": "s",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user/get_last_user_id_num', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          let last_user_id_num = response.data["data"]["last_user_id_num"];
          set_last_id_num(last_user_id_num);
        } else {

        }
      });
  };

  const get_mcomp_info_by_ajax = () => {
    if (strFunc.is_empty(user.comp_seq)) {
      return false;
    }
    let form_json_data: any = {
      s_seq: user.comp_seq,
      is_paging: "",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/mcomp/mcomp/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length > 0) {
            set_mcomp_info(response.data["data"]["info_arr"][0]);
          }
        } else {
        }
      });
  };

  const addRowByData = (inRowData: any) => {
    let rowData = {
      ...default_row_data,
      ...inRowData
    };

    let id_prefix = mcomp_info["a_id_prefix"];
    if (strFunc.is_empty(id_prefix)) {
      id_prefix = mcomp_info["a_id"] + ".";
    }
    id_prefix += "s";

    let last_num = strFunc.uncomma_int(last_id_num.replace(id_prefix, ""));
    if (strFunc.is_empty(rowData["a_user_id"])) {
      last_num = last_num + infoArr.length;
      last_num = strFunc.str_pad({ "str": last_num, "pad_length": 4 });
      rowData["a_user_id"] = id_prefix + "" + last_num;
    }

    let info_arr = [...infoArr];
    if (ListComponentRef.current) {
      info_arr = ListComponentRef.current.getRows();
      info_arr.push(rowData);
      ListComponentRef.current.setInfoArr(info_arr);
      setInfoArr(info_arr);
    }
  };

  const removeRowByData = () => {
    if (ListComponentRef.current == null) {
      return false;
    }
    let all_rows = ListComponentRef.current.getRows();
    let select_rows = ListComponentRef.current.getSelectedRows();
    let now_rows = [];
    for (let i = 0; i < all_rows.length; i++) {
      let is_select = false;
      for (let j = 0; j < select_rows.length; j++) {
        if (select_rows[j].idx_num == i) {
          is_select = true;
        }
      }
      if (is_select == false) {
        now_rows.push(all_rows[i]);
      }
    }
    ListComponentRef.current.setInfoArr(now_rows);
    setInfoArr(now_rows);
  };

  const onExcelCallBack = (rows: any) => {
    let add_row_arr = [];
    for (let i = 0; i < rows.length; i++) {
      add_row_arr.push({
        ...default_row_data,
        ...rows[i],
      });
    }
    if (ListComponentRef.current) {
      let pre_info_arr = ListComponentRef.current.getRows();
      pre_info_arr = [
        ...pre_info_arr,
        ...add_row_arr
      ];
      ListComponentRef.current.setInfoArr(pre_info_arr);
      setInfoArr(pre_info_arr);
    }
  };

  const onWriteMulty = () => {
    let select_rows: any = [];
    if (ListComponentRef.current) {
      select_rows = ListComponentRef.current.getRows();
    }
    if (select_rows.length == 0) {
      alert("데이터가 없습니다.");
      return false;
    }

    for (let i = 0; i < select_rows.length; i++) {
      let info = select_rows[i];
      if (strFunc.is_empty(info["a_user_name"])) {
        alert((i + 1) + "번째 학생 이름을 입력해주세요.");
        return false;
      }

    }

    if (!confirm("등록 하시겠습니까?")) {
      return false;
    }

    //학부모 핸드폰 끝자리와 출결번호 세팅
    for (let i = 0; i < select_rows.length; i++) {
      let info = select_rows[i];
      if (!strFunc.is_empty(info["par_phone"]) && info["par_phone"].length > 8) {
        if (strFunc.is_empty(info["a_stu_num"])) {
          select_rows[i]["a_stu_num"] = strFunc.getNumber2(info["par_phone"].slice(-4));
        }
      }
      if (myProps.isUpdate == false) {
        //비밀번호 세팅
        if (strFunc.is_empty(info["a_user_pw"])) {
          select_rows[i]["a_user_pw"] = "1111";
        }
      }
      if (info["par_phone"]) {

        let par_name = info["a_user_name"];
        if (info["par_relation"] == "모") {
          par_name += " 어머니";
        } else if (info["par_relation"] == "부") {
          par_name += " 아버지";
        } else if (info["par_relation"] == "etc") {
          par_name += " 부모님";
        } else {
          par_name += " " + info["par_relation"];
        }

        select_rows[i].write_par_arr = [
          {
            "a_seq": "",
            "a_user_phone": info["par_phone"],
            "a_user_id": info["par_user_id"],
            "a_user_pw": info["par_user_pw"],
            "a_relation": info["par_relation"],
            "a_order": "0",
            "a_is_attend_sms": info["par_is_attend_sms"],
            "a_is_attend_push": info["par_is_attend_push"],
            "a_is_attend_katalk": info["par_is_attend_katalk"],
          }
        ];
      }
    }

    let formJsonData = {
      "data_arr": select_rows,
      "is_default_val": "1",
      "is_update": "",
      "is_write_parent": "1",
    };
    if (myProps.isUpdate) {
      formJsonData["is_default_val"] = "";
      formJsonData["is_update"] = "1";
    }
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user/write_student', formJsonData, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert(response.data["msg"]);
          myProps.callBackData({});
          myProps.closePopup();
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const onChangeInput = (params: any) => {
    /*
      {
        "rowData":rowData,
        "row_num":row_num,
        "key":key,
        "value":row_val,
        "pre_value":"",
      }
      */
    if (params.key == "par_phone") {
      //a_stu_num
      let tmp_par_phone = strFunc.getNumber2(params.value);
      if (tmp_par_phone.length == 11) {
        // params.rowData["a_stu_num"] = strFunc.getNumber2(tmp_par_phone.slice(-4));
      }
    }
    return params;
  };

  const cellClickedListener = useCallback((rowData: any, idx: number, e: any) => {

  }, []);

  const cellRenderer = useCallback((inOpt: any) => {
    let opObj = {
      "rowData": {},
      "idx": 0,
      "key": "",
      "value": "",
      ...inOpt
    };

    return opObj.value;
  }, []);

  const gridCellRenderer = (params: any) => {
    /*
    {
      "rowData":rowData,
      "idx":idx,
      "key":key,
      "value":row_val,
      "input_tag":input_tag,
      "onChangeInput":onChangeInput,
    }
    */
    if (params.key == "a_stu_num") {
      params.input_tag = (
        <input type="text" className="row-input" name={params.key} value={strFunc.getNumber2(params.value)}
          onChange={(e: any) => {
            params.onChangeInput({
              "rowData": params.rowData,
              "row_num": params.idx,
              "key": params.key,
              "value": e.target.value,
              "pre_value": params.value,
              "event": e,
            });
          }}
          style={{ width: "98%" }} />
      );
    }
    return params.input_tag;
  };

  return (
    <div>
      <div className="btn-box-left relative" style={{ minHeight: 30 }}>
        <b>총 <span className="text-blue-600">{infoArr.length}</span> 개</b>
        <span className="px-2">|</span>
        <button className="btn btn-blue" onClick={() => { onWriteMulty(); }}>등록</button>
        <button className="btn btn-line-gray" onClick={() => { addRowByData({}); }}>추가</button>
        <button className="btn btn-line-gray" onClick={() => { removeRowByData(); }}>제거</button>

        <button className="btn btn-line-gray ml-3" onClick={() => { setIsOpenExcel(true); }}>엑셀업로드</button>
        <div className="absolute right-0 top-0 btn-box-right">
          <button className="btn btn-line-gray" onClick={() => { myProps.closePopup(); }}>닫기</button>
        </div>
      </div>
      <ListComponent
        ref={ListComponentRef}
        infoArr={infoArr}
        xColumnArr={{ ...xColumnArr }}
        gridOpt={{
          isGrid: true,
          is_add_idx_num: false,
          is_add_checkbox: true,
          td_align: "left",//center,right
          table_align: "left",//center,right
          onGridReady: () => { },
          rowOnClick: cellClickedListener,
          customCellRenderer: cellRenderer,
          customGridCellRenderer: gridCellRenderer,
          onChangeInput: onChangeInput,
        }}
      ></ListComponent>

      {isOpenExcel &&
        <ExcelUploadArea
          onClose={() => { setIsOpenExcel(false); }}
          onCallback={(inData: any) => { onExcelCallBack(inData); }}
          xColumnArr={xColumnArr}
        ></ExcelUploadArea>
      }
    </div>
  );
}

export default WriteMultyPopup;